/**
 * Lightweight scroll reveals for Purity Fields sections.
 * Uses IntersectionObserver — no layout thrash, respects reduced motion.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-pf-reveal]';
  var READY = 'is-revealed';

  function revealAll(nodes) {
    nodes.forEach(function (el) {
      el.classList.add(READY);
    });
  }

  function init() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
    if (!nodes.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      revealAll(nodes);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      revealAll(nodes);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add(READY);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    nodes.forEach(function (el) {
      if (!el.classList.contains(READY)) observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
